import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { DaysAvailability } from "../../../settings/daysAvaibility";
import { StepNavigation } from "../navigation";
import { getDaySliceFieldPaths, validateDaySlices } from "../../../../utils";

const TutorAvailability = ({ setCurrentStep }) => {
    const methods = useFormContext();
    const [isLoading, setIsLoading] = useState(false);
    const { errors: formErrors } = methods.formState;

    const onNext = async () => {
        setIsLoading(true);
        try {
            methods.clearErrors("days");
            const days = methods.getValues("days") || [];
            const fieldPaths = getDaySliceFieldPaths(days);
            const { isValid, fieldErrors } = validateDaySlices(days);

            fieldErrors.forEach(({ path, message }) => {
                methods.setError(path, { type: "manual", message });
            });

            const fieldsValid = fieldPaths.length
                ? await methods.trigger(fieldPaths)
                : isValid;

            if (fieldsValid && isValid) {
                setCurrentStep(6);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col">
            <h2 className="mb-2 text-xl text-nt-blue">Availability</h2>
            <p className="text-nt-grey text-sm mb-4">
                Set your weekly teaching hours. You can adjust these later in settings.
            </p>

            {formErrors.days?.message ? (
                <p className="text-nt-red text-sm mb-4">{formErrors.days.message}</p>
            ) : null}
            {formErrors.days && !formErrors.days.message ? (
                <p className="text-nt-red text-sm mb-4">
                    Please fix the highlighted time slots before continuing.
                </p>
            ) : null}

            <div className="rounded-xl border border-nt-grey-light p-4 md:p-6 mb-4">
                <DaysAvailability widthClass="w-full" />
            </div>

            <StepNavigation
                moveBack={() => setCurrentStep(4)}
                moveForward={onNext}
                isLoading={isLoading}
            />
        </div>
    );
};

export { TutorAvailability };
